/* Passion Fruit soap page. Size picker, gallery, and soft add to cart. */
(function(){
function boot(){
  var root=document.querySelector('.pf'); if(!root) return;
  var money=function(cents){ return '$'+(cents/100).toFixed(2).replace(/\.00$/,'.00'); };

  /* ---------- soft add to cart ---------- */
  function bumpCount(){
    fetch(window.Shopify&&window.Shopify.routes?window.Shopify.routes.root+'cart.js':'/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json()})
      .then(function(cart){
        var sel='[data-cart-count],.cart-count,.cart-link__bubble-num,.header__cart-count,#CartCount,.cart-count-bubble span';
        document.querySelectorAll(sel).forEach(function(el){ el.textContent=cart.item_count; });
        document.documentElement.classList.add('pf-cart-updated');
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart:cart}}));
        document.dispatchEvent(new CustomEvent('cart:build',{bubbles:true}));
      }).catch(function(){});
  }

  /* ---------- tell Shopify and any tracking apps that something was added ---------- */
  function report(j){
    try{
      var it=(j && j.items && j.items[0]) || j; if(!it || !it.variant_id) return;
      var money=function(c){ return { amount:(c||0)/100, currencyCode:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD' } };
      if(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish==='function'){
        Shopify.analytics.publish('product_added_to_cart',{ cartLine:{
          cost:{ totalAmount: money(it.final_line_price) },
          merchandise:{ id:'gid://shopify/ProductVariant/'+it.variant_id, price: money(it.final_price),
            product:{ id:'gid://shopify/Product/'+it.product_id, title:it.product_title, vendor:it.vendor, type:it.product_type, untranslatedTitle:it.product_title, url:it.url },
            sku:it.sku, title:it.variant_title, untranslatedTitle:it.variant_title },
          quantity:it.quantity } });
      }
      if(typeof window.fbq==='function'){ fbq('track','AddToCart',{content_ids:[String(it.variant_id)], content_name:it.product_title, value:(it.final_line_price||0)/100, currency:'USD', content_type:'product'}); }
      if(typeof window.gtag==='function'){ gtag('event','add_to_cart',{currency:'USD', value:(it.final_line_price||0)/100, items:[{item_id:String(it.variant_id), item_name:it.product_title, quantity:it.quantity, price:(it.final_price||0)/100}]}); }
      document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
      document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart:j}}));
    }catch(e){}
  }

  function add(id, qty, onDone, onFail){
    var url=(window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/')+'cart/add.js';
    fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:parseInt(id,10),quantity:qty||1}]})})
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(j){ bumpCount(); report(j); if(onDone) onDone(); })
      .catch(function(){ if(onFail) onFail(); });
  }

  /* ---------- size picker ---------- */
  var opts=[].slice.call(root.querySelectorAll('.opt'));
  var price=root.querySelector('.price'), each=root.querySelector('.each');
  var sName=document.querySelector('.stick .sv'), atc=root.querySelector('.atc');
  var stickBtn=document.querySelector('.stick button');
  var confirm=root.querySelector('.confirm');
  var current=null;
  function pick(o){
    current=o;
    opts.forEach(function(x){ x.classList.toggle('on', x===o) });
    if(price) price.textContent=o.getAttribute('data-price');
    if(each) each.textContent=o.getAttribute('data-sub');
    if(sName) sName.textContent=o.getAttribute('data-name')+' \u00b7 '+o.getAttribute('data-price');
    var sold=o.getAttribute('data-available')==='false';
    [atc,stickBtn].forEach(function(b){ if(!b) return; b.disabled=sold; b.textContent=sold?'Sold out':b.getAttribute('data-label')||'Add to cart'; });
    var u=new URL(window.location); u.searchParams.set('variant',o.getAttribute('data-id'));
    window.history.replaceState({},'',u);
  }
  opts.forEach(function(o){ o.addEventListener('click',function(){ pick(o) }) });
  if(opts.length){ pick(root.querySelector('.opt.on')||opts[0]); }

  function say(msg){ if(!confirm) return; confirm.textContent=msg; confirm.classList.add('on');
    clearTimeout(confirm._t); confirm._t=setTimeout(function(){ confirm.classList.remove('on'); confirm.textContent=''; },4000); }

  [atc,stickBtn].forEach(function(btn){
    if(!btn) return;
    btn.setAttribute('data-label',btn.textContent.trim());
    btn.addEventListener('click',function(e){
      e.preventDefault();
      if(!current) return;
      var label=btn.getAttribute('data-label');
      btn.disabled=true; btn.textContent='Adding';
      add(current.getAttribute('data-id'),1,function(){
        btn.textContent='Added'; say('Added to your cart. Keep looking, it is saved.');
        setTimeout(function(){ btn.disabled=false; btn.textContent=label; },1800);
      },function(){
        btn.disabled=false; btn.textContent=label; say('That did not go through. Try once more.');
      });
    });
  });

  /* ---------- gallery ---------- */
  var sl=root.querySelector('.slider');
  if(sl){
    var slides=[].slice.call(sl.children);
    var dots=[].slice.call(root.querySelectorAll('.dots i'));
    var at=function(){ return Math.round(sl.scrollLeft/sl.clientWidth) };
    var mark=function(){ var i=at(); dots.forEach(function(d,n){ d.classList.toggle('on',n===i) }) };
    var go=function(n){ n=Math.max(0,Math.min(slides.length-1,n)); sl.scrollTo({left:n*sl.clientWidth,behavior:'smooth'}) };
    sl.addEventListener('scroll',mark);
    dots.forEach(function(d,n){ d.style.cursor='pointer'; d.addEventListener('click',function(){ go(n) }) });
    var p=root.querySelector('.gnav.prev'), nx=root.querySelector('.gnav.next');
    if(p) p.addEventListener('click',function(){ go(at()-1) });
    if(nx) nx.addEventListener('click',function(){ go(at()+1) });
    mark();
  }


  /* ---------- videos: right size for the screen, load only when needed ---------- */
  (function(){
    var vids=[].slice.call(document.querySelectorAll('video.pfvid'));
    if(!vids.length) return;
    var small=window.matchMedia('(max-width: 899px)').matches;
    function load(v){
      if(v.dataset.loaded) return; v.dataset.loaded='1';
      var url=(small && v.dataset.small) ? v.dataset.small : v.dataset.big;
      if(!url) url=v.dataset.alt||'';
      var s=document.createElement('source'); s.src=url; s.type='video/mp4'; v.appendChild(s);
      if(v.dataset.alt && v.dataset.alt!==url){ var s2=document.createElement('source'); s2.src=v.dataset.alt; s2.type='video/mp4'; v.appendChild(s2); }
      v.preload='auto'; v.muted=true; v.playsInline=true; v.load();
      var tries=0;
      function go(){
        if(v.paused===false) return;
        var pr=v.play();
        if(pr && pr.catch) pr.catch(function(){ if(++tries<6) setTimeout(go,600); });
      }
      v.addEventListener('loadeddata',go);
      v.addEventListener('canplay',go);
      go(); setTimeout(go,900);
      document.addEventListener('touchstart',go,{once:true,passive:true});
    }
    vids.forEach(function(v){
      if(v.dataset.eager){ load(v); return; }
      if(!('IntersectionObserver' in window)){ load(v); return; }
      var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ load(v); io.disconnect(); } }); },{rootMargin:'600px 0px'});
      io.observe(v);
    });
  })();

  /* ---------- pairing cards, soft add ---------- */
  [].slice.call(document.querySelectorAll('.cadd')).forEach(function(b){
    var label=b.innerHTML;
    b.addEventListener('click',function(e){
      e.preventDefault();
      var id=b.getAttribute('data-id'); if(!id) return;
      b.disabled=true; b.innerHTML='Adding';
      add(id,1,function(){
        b.classList.add('done'); b.innerHTML='Added';
        setTimeout(function(){ b.classList.remove('done'); b.innerHTML=label; b.disabled=false; },1800);
      },function(){ b.innerHTML=label; b.disabled=false; });
    });
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
